<div [formGroup]="form">
  <ng-container>
    <div class="section">Gebäudedaten</div>
    <div class="grid">
      <div class="md:col-3">
        <label class="label" for="name">Name</label>
        <input fullWidth id="name" nbInput formControlName="name">
        @if (hasError('name')) {
          <div class="error">Name ist erforderlich!</div>
        }
      </div>
      @if (form.get('buildingType')?.value === 'OTHER') {
        <div class="md:col-3">
          <label class="label" for="otherBuildingType">Anderer Typ</label>
          <input fullWidth id="otherBuildingType" nbInput formControlName="otherBuildingType">
        </div>
      }
      <div class="md:col-3">
        <label class="label" for="externalNumber">Objektnummer Extern</label>
        <input fullWidth id="externalNumber" nbInput formControlName="externalNumber">
      </div>
      <div class="md:col-3">
        <label class="label" for="buildingType">Gebäudetyp</label>
        <wr-building-type-select id="buildingType" formControlName="buildingType"></wr-building-type-select>
        @if (hasError('buildingType')) {
          <div class="error">Gebäudetyp ist erforderlich!</div>
        }
      </div>
      <div class="md:col-3">
        <label class="label" for="buildingClass">Gebäudeklasse</label>
        <wr-building-class-select id="buildingClass" formControlName="buildingClass"></wr-building-class-select>
        @if (hasError('buildingClass')) {
          <div class="error">Gebäudeklasse ist erforderlich!</div>
        }
      </div>
      @if (form.get('buildingClass')?.value === 'OTHER') {
        <div class="md:col-3">
          <label class="label" for="otherBuildingClass">Andere Klasse</label>
          <input fullWidth id="otherBuildingClass" nbInput formControlName="otherBuildingClass">
        </div>
      }
      <div class="md:col-3">
        <label class="label" for="area">Wohnfläche (m²)</label>
        <input id="area" min="0" type="number" nbInput formControlName="area" fullWidth>
      </div>
      <div class="md:col-3">
        <label class="label" for="floorCountWithoutCellar">Stockwerke</label>
        <input id="floorCountWithoutCellar" type="text" nbInput fullWidth formControlName="floorCountWithoutCellar">
      </div>
      <div class="md:col-3 coordinates">
        <label for="coordinate-button" class="label">Koordinaten</label>
        <div class="coordinate-buttons">
          <button id="coordinate-button" [nbTooltip]="coordinateTooltip()"
                  nbTooltipStatus="primary"
                  class="coordinate-button" size="medium" [disabled]="form.disabled" nbButton
                  status="primary" (click)="openCoordinateDialog()">
            <nb-icon pack="eva" icon="globe-outline"></nb-icon>
            Koordinaten
          </button>
          @if (!form.disabled) {
            <button size="medium" [disabled]="form.disabled" nbButton status="primary" (click)="resetCoordinates()">
              <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
            </button>
          }
        </div>
        </div>
      <div class="col-break"></div>
      <div class="md:col-3">
        <label class="label" for="uid">UID-Nummer</label>
        <input id="uid" type="text" nbInput fullWidth formControlName="uid"
               class="muted-placeholder"
               nbTooltip="z. B. ATU12345678" nbTooltipStatus="primary">
      </div>
      <div class="md:col-3">
        <label class="label" for="insuranceNumber">Versicherungspolizze</label>
        <input id="insuranceNumber" type="text" nbInput fullWidth formControlName="insuranceNumber"
               class="muted-placeholder">
      </div>
      <div class="md:col-3">
        <label class="label" for="insuranceCompany">Versicherungsgesellschaft</label>
        <wr-insurance-company-select id="insuranceCompany" formControlName="insuranceCompany"></wr-insurance-company-select>
        @if (hasError('insuranceCompany')) {
          <div class="error">Versicherungsträger ist erforderlich!</div>
        }
      </div>
    </div>
  </ng-container>
</div>
